import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an application error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: 'var(--clr-bg)' }}>
          <div style={{ width: '100%', maxWidth: '520px', padding: '32px', borderRadius: '24px', background: 'var(--clr-surface)', border: '1px solid var(--clr-border)', boxShadow: '0 24px 80px rgba(44, 24, 19, 0.08)', textAlign: 'center' }}>
            <div style={{ width: '56px', height: '56px', margin: '0 auto 16px', borderRadius: '16px', background: 'var(--clr-danger-dim)', color: 'var(--clr-danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '22px' }}>
              P
            </div>
            <h1 style={{ margin: 0, marginBottom: '10px', fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: 800, color: 'var(--clr-text)' }}>
              Something went wrong
            </h1>
            <p style={{ margin: 0, marginBottom: '22px', fontSize: '14px', lineHeight: 1.7, color: 'var(--clr-text-2)' }}>
              The page hit an unexpected error. You can reload and continue, or return to the homepage.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={this.handleReload}
                style={{ padding: '12px 18px', borderRadius: '999px', border: '1px solid var(--clr-danger)', background: 'var(--clr-danger)', color: '#fff', fontSize: '14px', fontWeight: 700 }}
              >
                Reload page
              </button>
              <button
                type="button"
                onClick={this.handleGoHome}
                style={{ padding: '12px 18px', borderRadius: '999px', border: '1px solid var(--clr-border-md)', background: 'var(--clr-surface-2)', color: 'var(--clr-text)', fontSize: '14px', fontWeight: 700 }}
              >
                Go home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
